import api from './axios.service';
const axios = api;

const login = async (paylaod) => {
    try {
        let response = await axios.post(`/auth/login`, paylaod);
        return response.data;
    } catch (error) {
        return error?.response?.data || { error: error.message };
    }
}

export {
    login
};
